import { Info } from "@livechat/design-system-icons";
import { DesignToken, Icon, Text } from "@livechat/design-system-react-components";

import { EmptyState as EmptyStateComponent } from "components/empty-state/EmptyState";
import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

export const EmptyState: React.FC = () => (
  <Flex column alignItems="center">
    <EmptyStateComponent
      title="No logs"
      icon={<Icon source={Info} size="xxxlarge" customColor={withVar(DesignToken.ContentBasicSecondary)} />}
    >
      <Text size="xs" customColor={withVar(DesignToken.ContentBasicSecondary)}>
        There are no logs to display
      </Text>
    </EmptyStateComponent>
  </Flex>
);
